import { ArrowTopRightIcon, MagnifyingGlassIcon } from '@radix-ui/react-icons';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const { pathname } = useLocation();
  const onGrid = pathname === '/' || pathname === '/home';

  return (
    <header className="site-header">
      <div className="site-shell header-inner">
        <Link to="/" className="wordmark" aria-label="CFB Scorigami home">
          <svg className="brand-mark" width="34" height="34" viewBox="0 0 34 34" aria-hidden="true">
            <rect width="34" height="34" rx="8" fill="currentColor" />
            <path d="M9 9h4v4H9zm6 0h4v4h-4zm6 0h4v4h-4zM15 15h4v4h-4zm6 0h4v4h-4zm0 6h4v4h-4z" fill="#101118" />
            <path d="M9 15h4v4H9zm0 6h4v4H9zm6 0h4v4h-4z" fill="#101118" opacity=".28" />
          </svg>
          <span>CFB<span className="brand-accent">SCORIGAMI</span></span>
        </Link>
        <nav aria-label="Main navigation" className="site-nav">
          <Link to="/" aria-current={onGrid ? 'page' : undefined}>
            <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M2 2h4v4H2zm8 0h4v4h-4zM2 10h4v4H2zm8 0h4v4h-4z" stroke="currentColor" strokeWidth="1.4" />
            </svg>
            Score Grid
          </Link>
          <Link to="/score_lookup" aria-current={pathname === '/score_lookup' ? 'page' : undefined} className={!onGrid ? 'nav-active' : undefined}>
            <MagnifyingGlassIcon /> Score Lookup
          </Link>
        </nav>
        <a className="header-social" href="https://www.twitter.com/CFBScorigami_" target="_blank" rel="noreferrer">
          Follow on X <ArrowTopRightIcon />
        </a>
      </div>
    </header>
  );
}
